import { useEffect } from 'react';
import { useSocket } from '@/hooks/useSocket';
import { usePlanStore } from '@/stores/planStore';
import { BILLING_EVENTS } from '@/services/socket/socketEvents';

/**
 * Re-reads the plan when the backend announces a change (an LTD purchase
 * landing through the Stripe webhook), so the sidebar and feature gates unlock
 * without a reload. Mount once, in AppLayout.
 */
export function usePlanSocketEvents() {
  const { on, off, isConnected, connectionId } = useSocket();

  useEffect(() => {
    if (!isConnected) return;

    const handlePlanUpdated = () => {
      void usePlanStore.getState().hydrate();
    };

    on(BILLING_EVENTS.PLAN_UPDATED, handlePlanUpdated);
    return () => off(BILLING_EVENTS.PLAN_UPDATED, handlePlanUpdated);
  }, [isConnected, connectionId, on, off]);
}
